/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './ScrollTopButton.css';

function ScrollTopButton() {
  return (
    <>
      <button
        className="btnScrollTop"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <img src="static/amp/shared/assets/arrow-top.svg" alt="seta para cima" />
      </button>
      <style jsx>{Styles}</style>
    </>
  );
}

export default ScrollTopButton;
